import config from '@epi-config';
import { post } from '@epi-helpers/FetchHelpers';
import { getRecaptchaToken } from '@epi-helpers/ReCaptchaHelper';
import { getReCaptchaSiteKey } from '@epi-selectors/settings';

import { reduxStore } from '../../store-configuration';

const url = `${config.apiHost}/api/sign-up`;

export interface SignUpPayload {
  contactRegistrationType: string;
  token: string;
  userName: string;
  password: string;
  reCaptchaToken: string;
}

export interface ResendEmailPayload {
  token: string;
  contactRegistrationType: string | null;
  reCaptchaToken: string;
}

export interface ResendEmailResponse {
  token: string;
  contactRegistrationType: string;
}

export function signUpRequest(payload: SignUpPayload): Promise<any> {
  return post(url, payload);
}

export function resendSignUpEmailRequest(
  payload: ResendEmailPayload
): Promise<ResendEmailResponse> {
  return post(`${url}/resend-email`, payload);
}

export async function isSignupTokenValidRequest(
  token: string,
  contactRegistrationType: string
): Promise<any> {
  const state = reduxStore.getState();
  const reCaptchaSiteKey = getReCaptchaSiteKey(state);

  const reCaptchaToken = await getRecaptchaToken(
    reCaptchaSiteKey,
    'CHECK_SIGNUP_TOKEN_VALIDITY'
  );

  return post(`${url}/validate-token`, {
    contactRegistrationType,
    token,
    reCaptchaToken
  });
}
